import { z } from 'zod'

export const MessageTypeEnum = z.enum(
	['question', 'help', 'feedback', 'other'],
	{
		errorMap: (issue, ctx) => {
			if (
				issue.code === z.ZodIssueCode.invalid_enum_value ||
				issue.code === z.ZodIssueCode.invalid_type
			) {
				return { message: 'A selection is required' }
			}
			return { message: ctx.defaultError }
		},
	},
)
export const HelpTypeEnum = z.enum(['venue', 'leader', 'website', 'other'])

export const MessageSchema = z.object({
	messageType: MessageTypeEnum,
	helpType: HelpTypeEnum.optional(),
	firstName: z
		.string({ required_error: 'Please enter your first name' })
		.max(50, 'First name is too long')
		.trim(),
	lastName: z.string().max(50, 'Last name is too long').trim().optional(),
	email: z
		.string({ required_error: 'Please enter your email address' })
		.trim()
		.email('Invalid email address')
		.toLowerCase(),
	message: z.string().trim().optional(),
})

export type MessageType = z.infer<typeof MessageTypeEnum>
export type HelpType = z.infer<typeof HelpTypeEnum>

export const messageTypeLabels: Record<MessageType, string> = {
	[MessageTypeEnum.enum.help]: 'I want to help',
	[MessageTypeEnum.enum.question]: 'I have a question',
	[MessageTypeEnum.enum.feedback]: 'I have feedback or a suggestion',
	[MessageTypeEnum.enum.other]: 'Other',
}

export const helpTypeLabels: Record<HelpType, string> = {
	[HelpTypeEnum.enum.venue]: 'I have a venue you should check out',
	[HelpTypeEnum.enum.leader]: 'I can lead events',
	[HelpTypeEnum.enum.website]: 'Website development or other technical',
	[HelpTypeEnum.enum.other]: 'Other',
}
